define('home/views/ChannelPromotionView',[
    'backbone-marionette',

    'core/mixins/withChannelFollowing',

    'home/views/ChannelPromotionDiscussionView',
    'home/views/FetchingView',

    'home/mixins/withSubviews',

    'home/templates/channelPromotion',
], function (
    Marionette,

    withChannelFollowing,

    ChannelPromotionDiscussionView,
    FetchingView,

    withSubviews,

    channelPromotionTemplate
) {
    'use strict';

    /**
     * A view that shows promotional info about a channel. Shows the tile, description,
     * top discussions, follow button, and stats, in a small card.
     *
     * Expects a ChannelProfile model.
     */
    var ChannelPromotionView = Marionette.ItemView.extend({
        className: 'channels-module__block',
        template: channelPromotionTemplate,

        regions: {
            discussionsRegion: '[data-role=discussions]',
        },

        templateHelpers: function () {
            var primaryForum = this.model.channel.primaryForum;
            var numThreads = primaryForum.get('numThreads');
            var numFollowers = primaryForum.get('numFollowers');
            return {
                // Attributes may be null during fetch
                numThreads: numThreads && numThreads.toLocaleString(),
                numFollowers: numFollowers && numFollowers.toLocaleString(),
            };
        },

        initialize: function () {
            this.bindToPrimaryForum();
        },

        bindToPrimaryForum: function () {
            var channel = this.model.channel;
            if (!channel.primaryForum) {
                this.listenToOnce(channel, 'changeRelated:primaryForum', this.bindToPrimaryForum);
                return;
            }

            this.listenTo(channel.primaryForum, 'change:numThreads change:numFollowers', this.render);
        },

        onRender: function () {
            this.activateRegion(this.discussionsRegion, this.createDiscussionsRegion);
        },

        createDiscussionsRegion: function () {
            return new Marionette.CollectionView({
                itemView: ChannelPromotionDiscussionView,
                itemViewOptions: function (_item, index) {
                    return {
                        className: index > 1 ? 'hidden' : 'channels-module__article',
                    };
                },
                collection: this.model.topActivities.items,
                emptyView: function () {
                    return new FetchingView({
                        className: 'spinner-small',
                    });
                },
            });
        },
    });

    var proto = ChannelPromotionView.prototype;
    withChannelFollowing.call(proto, function () {
        return this.model.channel;
    });
    withSubviews.call(proto);

    return ChannelPromotionView;
});

